import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import swal from "sweetalert";
import {
  CREATE_USER,
  UPDATE_USER,
  ACTIVATE_USER,
  DEACTIVATE_USER,
} from "../../data/userData";
import {
  fetchDataEngine,
  generateAndExecuteMutationException,
  graphqlQuery,
} from "../../data/Axios/DynamicService";
import {
  allCompanies,
  allRegions,
  getrolesquery,
  allUsersQuery,
  allGenders,
} from "../../data/Axios/queries";
import {
  companyManagementUrl,
  roleManagemenUrl,
  setupManagementUrl,
  userManagementUrl,
} from "../../config";
import DynamicForm from "../../data/Axios/DynamicForm";
import { usersField } from "../../data/DynamicTable/usersDynamicForms";
import Swal from "sweetalert2";

const base_url = roleManagemenUrl.uri;

const UsersForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const tokenRegionId = parseInt(decodedToken.RegionId);
  const tokenBranchId = parseInt(decodedToken.BranchId);

  const [roleData, setRoleData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState([]);
  const [showRegions, setShowRegions] = useState(false);
  const [showBranches, setShowBranches] = useState(false);
  const [genderData, setGenderData] = useState([]);
  const [branchoptionsInitialvalue, setBranchOptionsInitialValue] = useState(
    []
  );
  const [branchIdData, setBranchIdData] = useState(null);
  const [regionIdData, setRegionIdData] = useState(null);
  const [showRegionsOnly, setShowRegionsOnly] = useState(false);
  const initialValues = {
    firstName: props.userData ? props.userData.firstName : "",
    lastName: props.userData ? props.userData.lastName : "",
    email: props.userData ? props.userData.email : "",
    phone: props.userData ? props.userData.phone : "",
    username: props.userData ? props.userData.username : "",
    idno: props.userData ? props.userData.idno : "",
    roleId: props.userData ? props.userData.roleId : "",
    roleName: props.userData ? props.userData.roleName : "",
    companyId: props.userData ? props.userData.companyId : "",
    genderId: props.userData ? props.userData.genderId : "",
    regionId: props.userData ? props.userData.regionId : "",
    branchId: props.userData ? props.userData.branchId : "",
  };

  useEffect(() => {
    async function fetchAllData() {
      try {
        const facts = await graphqlQuery(getrolesquery, base_url);
        if (facts) {
          setRoleData(facts);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchAllData();
  }, []);

  useEffect(() => {
    async function fetchAllData() {
      try {
        const regionResponse = await graphqlQuery(
          allRegions,
          companyManagementUrl.uri
        );
        if (regionResponse) {
          setRegionData(regionResponse || []);
        }

        // Fetch branch data if userData has regionId
        if (tokenRegionId) {
          const branchResponse = await fetchBranches(tokenRegionId);
          setBranchData(branchResponse || []);
        }

        // Determine visibility of regions and branches
        if (props.userData && props.userData.roleId) {
          handleRoleChange(props.userData.roleId);
        }
        // const genderResponse = await graphqlQuery(
        //   allGenders,
        //   setupManagementUrl.uri
        // );
        // if (genderResponse) {
        //   setGenderData(genderResponse);
        // }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchAllData();
  }, [props.userData]);

  const fetchBranches = async (regionId) => {
    try {
      const query = `
        query { 
          allBranchesByColumnValues(branchModel: { regionId: ${regionId} }) { 
            id 
            branchName 
          } 
        }
      `;

      // Execute the GraphQL query
      const response = await graphqlQuery(query, companyManagementUrl.uri);

      // Log the full response to see its structure

      // Check if the response contains the expected array of branches
      if (response && Array.isArray(response)) {
        // Map the branches if response is an array
        const branches = response.map((branch) => ({
          value: branch.id,
          label: branch.branchName,
        }));

        return branches; // Return the mapped branch options
      }

      // Log a warning if the expected structure is not found
      console.warn("No branches found for the given regionId:", regionId);
      return [];
    } catch (error) {
      console.error("Error fetching branches:", error);
      return [];
    }
  };

  const handleFieldChange = async (field, value) => {
    if (field.name === "roleId") {
      handleRoleChange(value);
    }
    if (field.name === "regionId") {
      const branchOptions = await fetchBranches(value);
      setBranchOptionsInitialValue(branchOptions || []); // Ensure an array is set
      setBranchData(branchOptions); // Set the branch data for further rendering in form
      setBranchIdData(null); // Reset the branchId data if region changes
      return branchOptions;
    }
  };

  const handleRoleChange = (roleId) => {
    const selectedRole = roleData.find((role) => role.id === parseInt(roleId));
    if (selectedRole) {
      const { roleGroupId } = selectedRole;
      const tokenRoleGroupId = parseInt(decodedToken.RoleGroupId);
      if (tokenRoleGroupId === 1 || tokenRoleGroupId === 2) {
        if (roleGroupId === 1 || roleGroupId === 2) {
          setShowRegions(false);
          setShowBranches(false);
          setShowRegionsOnly(false);
        } else if (roleGroupId === 3) {
          setShowRegionsOnly(true);
          setShowRegions(false);
          setShowBranches(false);
        } else if (roleGroupId === 4) {
          setShowRegions(true);
          setShowBranches(false);
          setShowRegionsOnly(false);
        }
      } else if (tokenRoleGroupId === 3) {
        if (roleGroupId === 3) {
          setShowRegionsOnly(false);
          setShowRegions(false);
          setShowBranches(false);
          setRegionIdData(tokenRegionId);
        } else if (roleGroupId === 4) {
          setShowRegions(false);
          setShowBranches(true);
          setShowRegionsOnly(false);
          setRegionIdData(tokenRegionId);
        }
      } else {
        if (roleGroupId === 4) {
          setShowRegions(false);
          setShowBranches(false);
          setShowRegionsOnly(false);
          setBranchIdData(tokenBranchId);

          setRegionIdData(tokenRegionId);
        }
      }
      // if (roleGroupId === 1 || roleGroupId === 2) {
      //   setShowRegions(false);
      //   setShowBranches(false);
      // } else if (roleGroupId === 3) {
      //   setShowRegions(false);
      //   setShowBranches(true);
      // } else if (roleGroupId === 4) {
      //   setShowRegions(false);
      //   setShowBranches(false);
      // }
    }
  };
  // const companyOptions = companyData
  //   ? companyData.map((company) => ({
  //       value: company.id,
  //       label: company.companyName,
  //     }))
  //   : [];

  const roleOptions = roleData
    ? roleData.map((role) => ({
        parent_key: role.id,
        value: role.id,
        label: role.role,
      }))
    : [];
  const regionOptions = regionData
    ? regionData.map((role) => ({
        parent_key: role.id,
        value: role.id,
        label: role.regionName,
      }))
    : [];

  // const genderOptions = genderData
  //   ? genderData.map((user) => ({
  //       parent_key: user.id,
  //       value: user.id,
  //       label: user.gender,
  //     }))
  //   : [];
  // const branchOptions = branchData
  //   ? branchData.map((user) => ({
  //       value: user.id,
  //       label: user.branchName,
  //     }))
  //   : [];
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        firstName,
        lastName,
        email,
        phone,
        username,
        idno,
        roleId,
        gender,
        companyId,
        regionId,
        branchId,
      } = values;

      const mutationData = {
        firstName,
        lastName,
        email,
        phone,
        username,
        idno,

        branchId: branchId || branchIdData || null,
        regionId: regionId || regionIdData || null,
        roleId: parseInt(roleId),
        companyId: parseInt(companyId),
        createdBy: userId,
      };

      if (props.isEditing) {
        mutationData.id = props.userData.id;
      }

      const response = await generateAndExecuteMutationException(
        props.isEditing ? "updateUser" : "createUser",
        mutationData,
        "user",
        userManagementUrl.uri
      );

      if (response.status === 200 && response.data) {
        props.onClose();
        props.refetch();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Record ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      } else if (response.errors) {
        // props.onClose();
        //props.refetch();
        Swal.fire({
          icon: "error",
          title: "Error!",
          text:
            response.errors[0].message || "An internal server error occurred.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  const fields = [
    ...usersField,

    {
      name: "roleId",
      label: "Role *",
      type: "select",
      options: roleData
        ? roleData.map((role) => ({
            value: role.id,
            label: role.role,
          }))
        : [],
      gridColumn: "span 2",
      required: true,
      parent: "main",
    },
    ...(showRegionsOnly
      ? [
          {
            name: "regionId",
            label: "Region *",
            type: "select",
            options: regionData
              ? regionData.map((region) => ({
                  value: region.id,
                  label: region.regionName,
                }))
              : [],
            gridColumn: "span 2",
            //parent: "main",
          },
        ]
      : []),
    ...(showRegions
      ? [
          {
            name: "regionId",
            label: "Region *",
            type: "select",
            options: regionData
              ? regionData.map((region) => ({
                  value: region.id,
                  label: region.regionName,
                }))
              : [],
            gridColumn: "span 2",
            parent: "main",
          },
          {
            name: "branchId",
            label: "Branch *",
            type: "select",
            options: branchData,
            gridColumn: "span 2",
            required: true,
            parent: "dependent",
            dependentOn: "regionId",
          },
        ]
      : []),
    ...(showBranches
      ? [
          {
            name: "branchId",
            label: "Branch *",
            type: "select",
            options: branchData,
            gridColumn: "span 2",
            required: true,
            // parent: "dependent",
            // dependentOn: "regionId",
          },
        ]
      : []),
  ];

  return (
    <div>
      <DynamicForm
        initialValues={initialValues}
        fields={fields}
        onFieldChange={handleFieldChange}
        onSubmit={handleSubmit}
        title={props.isEditing ? "Edit User" : "Create User"}
        subtitle={
          props.isEditing ? "Edit an Existing User" : "Create a New User"
        }
      />
    </div>
  );
};

export default UsersForm;
